import { IInitialState } from 'store/models';
import { moduleStateSelector } from '../../selectors';

export function mainStateSelector(state: IInitialState) {
	return moduleStateSelector(state).main;
}
